import {usePage} from "@inertiajs/vue3";
import Bugsnag from "@bugsnag/js";

export function trackEvent(event, data) {
    if (typeof LTIAnalytics !== 'undefined') {
        const {props} = usePage()

        LTIAnalytics.init(props.lti_analytics.api_key, {
            endpoint: props.lti_analytics.api_url + '/api/v1',
            debug: true,
            autoTrack: true
        });

        if (data) {
            LTIAnalytics.track(event, data);
            console.log(`++ LTI Analytics: Tracked ${event}`);
        }
    } else {
        console.error(`++ LTI Analytics: Failed to track event ${event}. LTIAnalytics is not defined`);
        Bugsnag.notify(new Error('LTI Analytics is not defined'), function (bugsnagEvent) {
            bugsnagEvent.severity = 'warning';
            if (data) {
                bugsnagEvent.addMetadata('eventData', data);
            }
        })
    }
}

export function getFathomPostPrefix(routePrefix) {
    return routePrefix === 'members2' ? 'Member_Post' : 'Tour_Post'
}

export function trackFathomEvent(event) {
    if (typeof fathom !== 'undefined' ) {
        fathom.trackEvent(event);
    } else {
        console.error(`++ Fathom: Failed to track event ${event}. Fathom is not defined`);
        Bugsnag.notify(new Error('Fathom is not defined'), function (bugsnagEvent) {
            bugsnagEvent.severity = 'warning';
        })
    }
}
